// import useUserStore from '@/store/modules/user';

const pageEventFindConfig: {
  eventId: string;
  testLastStr?: string;
  testReg?: RegExp;
  testFunc?: (findUrl: string, triggerPageUrl?: string) => string | undefined;
}[] = [
  // {
  //   eventId: '1001',
  //   testReg: /\/home/,
  // },
  // {
  //   eventId: '1009',
  //   testReg: /\/dataview\/data-space/,
  // },
];
const eventIdMap = {};

const getEventIdByConfig = (findUrl, config, triggerPageUrl) => {
  const testLastStr = config.testLastStr;
  const testFunc = config.testFunc;
  const testReg = config.testReg;
  let eventId = '';
  if (testFunc) {
    eventId = testFunc(findUrl, triggerPageUrl);
  } else if (testLastStr) {
    // 最后位置匹配
    if (findUrl.indexOf(testLastStr) + testLastStr.length === findUrl.length) {
      eventId = config.eventId;
    }
  } else if (testReg) {
    if (testReg.test(findUrl)) {
      eventId = config.eventId;
    }
  }
  return eventId;
};

const fixDataFuncMap = {
  // '1002': (item) => {
  //   item.eventId = '1002';
  // }
};
const getEventId = (item) => {
  const distEventId = item.distEventId;
  if (distEventId) return distEventId;
  const sourceEventId = item.eventId;
  if (eventIdMap[item.eventId]) return eventIdMap[sourceEventId];
  const triggerPageUrl = item.triggerPageUrl;
  const findUrl = (item.triggerPageUrl || '').split('?')[0];
  for (let i = 0; i < pageEventFindConfig.length; i++) {
    const config = pageEventFindConfig[i];
    const eventId = getEventIdByConfig(findUrl, config, triggerPageUrl);
    if (eventId) {
      // if (!config.testFunc) {
      //   eventIdMap[sourceEventId] = eventId;
      // }
      return eventId;
    }
  }
};

/** 上一次已处理的 navigation PV 的 URL（用于过滤 Router replaceState 等同 URL 重复上报） */
let lastPvNavigationUrl: string | undefined;

const pvFix = (item) => {
  delete item.title;
  delete item.params;
  if (item.action === 'reload') return item;

  // 相同页面避免触发两次。
  const triggerPageUrl = item.triggerPageUrl || '';
  if (item.action === 'navigation') {
    if (
      lastPvNavigationUrl !== undefined &&
      triggerPageUrl === lastPvNavigationUrl
    ) {
      item._finalAdd = false;
      return item;
    }
    lastPvNavigationUrl = triggerPageUrl;
  }

  const eventId = getEventId(item);
  if (eventId) {
    item.eventId = eventId;
    if (fixDataFuncMap[eventId]) {
      fixDataFuncMap[eventId](item);
    }
    item._finalAdd = true;
  } else {
    item._finalAdd = false;
  }
  return item;
};

export default pvFix;
